import React from "react";

function HamburgerMenu({ isMobileMenuOpen, toggleMobileMenu }) {
  return (
    <button
      onClick={toggleMobileMenu}
      className="md:hidden focus:outline-none pr-4 z-50 flex flex-col gap-1.5 w-10 h-10 relative pt-2"
      aria-label="Toggle mobile menu"
    >
      {/* Top Bar */}
      <span
        className={`w-8 h-1 bg-white rounded transition-all duration-500 ${
          isMobileMenuOpen ? "rotate-45 translate-y-2 delay-500" : ""
        }`}
      ></span>

      {/* Middle Bar (Hidden when menu is open) */}
      <span
        className={`w-8 h-1 bg-white rounded transition-all duration-500 ${
          isMobileMenuOpen ? "opacity-0 delay-500" : ""
        }`}
      ></span>

      {/* Bottom Bar */}
      <span
        className={`w-8 h-1 bg-white rounded transition-all duration-500 ${
          isMobileMenuOpen ? "-rotate-45 -translate-y-3 delay-500" : ""
        }`}
      ></span>
    </button>
  );
}

export default HamburgerMenu;
